import './rideIcon.scss'
import WatchLaterIcon from '@mui/icons-material/WatchLater'
import TrackChangesIcon from '@mui/icons-material/TrackChanges'
import TurnedInIcon from '@mui/icons-material/TurnedIn'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { ReactElement } from 'react'

type status = 'draft' | 'pending' | 'assigned' | 'accepted' | 'pickup' | 'arriving' | 'in_progress' | 'driver_canceled' | 'finished' | 'user_canceled' | 'user_requested_cancel' | 'company_canceled'

const rideIconsByStatus: Map<status, ReactElement> = new Map([
  ['draft', <WatchLaterIcon key="draft-icon" className="ride-status-icon__draft" />],
  ['pending', <TrackChangesIcon key="pending-icon" className="ride-status-icon__pending" />],
  ['assigned', <TurnedInIcon key="assigned-icon" className="ride-status-icon__assigned" />],
  ['accepted', <KeyboardArrowUpIcon key="accepted-icon" className="ride-status-icon__accepted" />],
  ['pickup', <KeyboardArrowUpIcon key="pickup-icon" className="ride-status-icon__pickup" />],
  ['arriving', <KeyboardArrowUpIcon key="arriving-icon" className="ride-status-icon__arriving" />],
  ['in_progress', <KeyboardArrowDownIcon key="in-progress-icon" className="ride-status-icon__in_progress" />],
  ['driver_canceled', <NotInterestedIcon key="driver-canceled-icon" className="ride-status-icon__driver_canceled" />],
  ['finished', <CheckCircleIcon key="finished-icon" className="ride-status-icon__finished" />],
  ['user_canceled', <NotInterestedIcon key="user-canceled-icon" className="ride-status-icon__user_canceled" />],
  ['user_requested_cancel', <NotInterestedIcon key="user-requested-cancel-icon" className="ride-status-icon__user_requested_cancel" />],
  ['company_canceled', <NotInterestedIcon key="company-canceled-icon" className="ride-status-icon__company_canceled" />]
])

type RideIconProps = {
  status: string
}

const RideIcon = ({ status }: RideIconProps) => rideIconsByStatus.get(status as status)

export default RideIcon
